import React, {useLayoutEffect, useState} from "react";
import {getPrismicItems} from "../actions/prismicAction";
import {useDispatch} from "react-redux";
import {MyTuluPage} from "../components/MyTulu/MyTuluPage";
import getFirebase from "../firebase";
import {useParams} from "react-router";
import {proposal} from "../globalState";
import {getFirestore, doc, getDoc} from "firebase/firestore";

const MyTulu = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const [data, setData] = useState();

    useLayoutEffect(() => {
        dispatch(getPrismicItems());

        const docId = params.id.replaceAll("__", " ");

        const db = getFirestore(getFirebase());

        const docRef = doc(db, "my_tulu", docId);

        getDoc(docRef).then((res) => {
            const data = res.data();
            setData(data);
            Object.keys(data).forEach((key) => {
                if (key === "columns" || key === "rideItems") {
                    proposal[key] = JSON.parse(data[key]);
                    return;
                }
                proposal[key] = data[key];
            });
        });
        // One-time initial fetch on mount; adding params.id would re-fetch on a
        // route-id change (the component is not remounted in router v6), changing
        // the existing behavior. dispatch is stable so it is intentionally omitted too.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <MyTuluPage data={data}/>
        </>
    );
};

export {MyTulu as default};
